import { useState } from 'react';

import useAdminProfile from '../../auth/useAdminProfile';

const useDashboardLoading = () => {
  const [loading, setLoading] = useState(false);

  const { fetchProfile } = useAdminProfile();

  const getDashboardLoadingData = async () => {
    setLoading(true);

    Promise.resolve(fetchProfile())
      .then(() => setLoading(false))
      .catch(() => setLoading(false));
  };

  return { getDashboardLoadingData, loading };
};

export default useDashboardLoading;
